
<div class="row p-2 " style="display: flex;justify-content: space-between;">
  <div *ngIf="showName" class="col-md-7 mat-body-1 displayFlex">
      <span [innerHTML]="question.safeHtmlContent" class="inputLabel-p" style="text-align: justify;"></span>
      <span style="margin-left: 8px;" *ngIf="question.questionToolTip">
      <img class="dupIcon-padd iconzoom cursor"
           matTooltip="{{question.questionToolTip}}"
           src="/assets/icons/information_tooltip.svg"
           alt="info icon"
           matTooltipClass="my-custom-tooltip"
           matTooltipPosition="above"/>
      </span>
  </div>
  <div [ngClass]="{'col-md-4 pl-2': showName}">
    <div class="row wrap pl-3 mat-body-1" style="display:block" [ngClass]="{'ml-3': !showName}">
      <input [disabled]="IsReadOnly" class="p-2 blue-border" [ngClass]="{'w-60': showName && question.timeEnabled,'w-58': showName && !question.timeEnabled,'w-65': !showName}"      
      [(ngModel)]="selectedDate" type="date"    [ngClass]="{'pt-none':IsReadOnly}" 
      [required]="isConditionIsTrue" (change)="onDateChange($event.target.value)" [ariaLabel]="question.questionText" />
  
      <input [disabled]="IsReadOnly"  *ngIf="question.timeEnabled" class="mat-body-1 m-2 p-2 blue-border" [ngClass]="{'w-17': showName  && question.timeEnabled,'w-35': !showName}"      
      [(ngModel)]="selectedTime" type="time"  pattern="[0-9]{2}:[0-9]{2}"   [ngClass]="{'pt-none':IsReadOnly}" 
      [required]="isConditionIsTrue" placeholder="hh:mm AM" (change)="onTimeChange($event.target.value)" [ariaLabel]="question.questionText" />
    </div>
    
   <div *ngIf="errormgvisible">
     <div class="mat-body-1 errormsg margin-top" *ngFor="let error of validationerrormessage">{{error}}</div>
   </div>
   <div *ngIf="dateFlag"  class="error-msg mat-body-1">Please select Date</div>
  <!-- <div *ngIf="timeFlag" class="error-msg mat-body-1">Please select Time</div> -->
  </div>
</div>
